import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import PLAYER_TYPES from 'constants/player-types';
import { profileSelectors } from 'store/profile';
import {
  FavoriteButton,
  PrevButton,
  RewindButton,
  PlayButton,
  EPGButton,
  FFButton,
  NextButton,
  SettingButton,
} from './Buttons';
import { StyledButtonsWrapper } from './ControlsStyledComponents';
import { ACTION_TYPES } from '../playerConstants';

const config = {
  defaultElement: '#PLAY_BUTTON',
  enterTo: 'default-element',
};

interface IButtonsSetProps {
  defaultSection?: boolean;
  sectionName: string;
  onSectionFocus?: () => void;
  playerType: string;
  isSettingsAvailable?: boolean;
  isPrevAvailable?: boolean;
  isNextAvailable?: boolean;
  favorite?: boolean;
  isPlaying: boolean;
  onClick: (type) => void;
}

const ButtonsSet: React.FC<IButtonsSetProps> = (props) => {
  const { defaultSection = true, sectionName, onSectionFocus, playerType, favorite } = props;
  const { isSettingsAvailable, isPrevAvailable, isNextAvailable, isPlaying, onClick } = props;
  const isLoggedIn = useSelector(profileSelectors.selectIsLoggedIn);

  return (
    <StyledButtonsWrapper
      id="buttons-set"
      defaultSection={defaultSection}
      sectionName={sectionName}
      onFocus={onSectionFocus}
      config={config}
    >
      <FavoriteButton
        disabled={!isLoggedIn}
        isActive={favorite}
        onEnter={() => onClick(ACTION_TYPES.FAVORITE)}
      />
      <PrevButton onEnter={() => onClick(ACTION_TYPES.PREV)} disabled={!isPrevAvailable} />
      {playerType !== PLAYER_TYPES.CHANNEL && (
        <RewindButton onEnter={() => onClick(ACTION_TYPES.RW)} disabled={false} />
      )}
      {playerType === PLAYER_TYPES.CHANNEL ? (
        <EPGButton onEnter={() => onClick(ACTION_TYPES.EPG)} disabled={false} id="EPG_BUTTON" />
      ) : (
        <PlayButton
          onEnter={() => onClick(isPlaying ? ACTION_TYPES.PAUSE : ACTION_TYPES.PLAY)}
          disabled={playerType === PLAYER_TYPES.CHANNEL}
          isPlaying={isPlaying}
          id={'PLAY_BUTTON'}
        />
      )}
      {playerType !== PLAYER_TYPES.CHANNEL && (
        <FFButton onEnter={() => onClick(ACTION_TYPES.FF)} disabled={false} />
      )}
      <NextButton onEnter={() => onClick(ACTION_TYPES.NEXT)} disabled={!isNextAvailable} />
    </StyledButtonsWrapper>
  );
};

export default memo(ButtonsSet);
